module.exports = __webpack_public_path__ + "assets/LDropPerp2.0f5acc5e3d6b7ddbda13e88cd0e42548.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/LDropPerp2.gmt
// module id = 964
// module chunks = 0